import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AuthConfig, OAuthModule } from 'angular-oauth2-oidc';
import { authConfigProvider, OAuthModuleConfig } from './auth.config';
import { AuthConfigService } from './auth-config.service';
import { IdentificationProviderService } from './identification-provider.service';

export function initApp(authConfigService: AuthConfigService) {
  return () => authConfigService.initAuth();
}

@NgModule({
  imports: [
    OAuthModule.forRoot(),
  ],
  providers: [
    AuthConfigService,
    { provide: AuthConfig, useFactory: authConfigProvider },
    OAuthModuleConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthConfigService],
      multi: true,
    },
    IdentificationProviderService,
  ]
})
export class AuthModule { }
